import React, { useEffect, useRef, useState } from 'react';
import { Alert, Col, Form, InputNumber, Row, Input, Collapse, Radio, Checkbox, Card, Divider } from 'antd';
import * as THREE from 'three';
import { observer } from 'mobx-react-lite';
import QuickTurnBoltStore from '../../../stores/QuickTurnBoltStore';
import PortalLoading from 'components/PortalLoading';
import Threads from './Threads';
import ShaftLength from './ShaftLength';
import ThreadLength from './ThreadLength';
import MaterialSelector from './MaterialSelector';
import BoltHeadSelector from './BoltHeadSelector';
import StandardSelector from './StandardSelector';

interface Props {
    mode?: string;
    showNameInput?: boolean;
    showInterestIndicators?: boolean;
}

const BoltSpecificationForm = (props: Props) => {
    const { threading, thread_length, shaft_length } = QuickTurnBoltStore;

    const [form] = Form.useForm();

    function handleChangeThreading(value: string): void {
        if (value === 'Fully Threaded') {
            QuickTurnBoltStore.updateBoltById(QuickTurnBoltStore.boltToken, {
                thread_length: shaft_length - 0.1,
            });
        }
    }

    return (
        <>
            {!QuickTurnBoltStore.boltToken ? (
                <PortalLoading />
            ) : (
                <>
                    <Form
                        layout="vertical"
                        className="quick-turn-spec-form"
                        requiredMark={false}
                        form={form}
                        scrollToFirstError={false}
                        id="quickturn-part-spec-form"
                    >
                        <div className="pb-0 px-4 pt-2">
                            <Row gutter={[0, 0]} className="m-0">
                                <Col span={24}>
                                    <MaterialSelector />
                                </Col>
                                {/* <Col span={24}>
                                    <StandardSelector />
                                </Col> */}
                                <Col span={24}>
                                    <BoltHeadSelector />
                                </Col>
                                <Divider />
                                <Col span={24}>
                                    <Threads />
                                </Col>
                                <Divider className="mt-0 pt-0" />
                                <Form.Item label="Threading" className="m-0 p-0">
                                    <Radio.Group
                                        value={threading}
                                        options={[
                                            { value: 'Fully Threaded', label: 'Fully Threaded' },
                                            { value: 'Partially Threaded', label: 'Partially Threaded' },
                                        ]}
                                        onChange={(e: any) => {
                                            QuickTurnBoltStore.setThreading(e.target.value);
                                            handleChangeThreading(e.target.value);
                                        }}
                                    />
                                </Form.Item>
                                <Col span={24}>
                                    <ShaftLength />
                                </Col>
                                {threading === 'Partially Threaded' ? (
                                    <Col span={24}>
                                        <ThreadLength />
                                    </Col>
                                ) : null}
                            </Row>
                        </div>
                    </Form>
                </>
            )}
        </>
    );
};

export default observer(BoltSpecificationForm);
